import { BackgroundProcess, BackgroundChainProcess } from '../resources';
import { BackgroundJobFailed } from '../exceptions';

function timeout(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}

export async function checkBackgroundProcessStatus(id, type) {
    try {
        let status = null;

        if (type === 'chain') {
            status = await BackgroundChainProcess.find(id).get();
        } else {
            status = await BackgroundProcess.find(id).get();
        }

        if (status.finished) {
            return [true, null];
        }
    } catch (e) {
        return [false, e];
    }

    await timeout(1000);

    const finished = await checkBackgroundProcessStatus(id, type);
    return finished;
}

async function waitForBackgroundProcess(f, get, type) {
    let response = await f();

    if (response.status === 202) {
        const { backgroundProcessId } = response.data.data;

        const [finished, error] = await checkBackgroundProcessStatus(
            backgroundProcessId,
            type
        );

        if (error) {
            return null;
        }

        if (!get && finished) {
            return true;
        }

        response = await waitForBackgroundProcess(f, get, type);
    }

    return response;
}

function waitForBackgroundProcessWithData(jobs, type) {
    return Promise.all(
        jobs.map(
            ({ backgroundProcessId, extra }) =>
                new Promise(async (resolve) => {
                    const [finished] = await checkBackgroundProcessStatus(
                        backgroundProcessId,
                        type
                    );
                    if (!finished) {
                        throw new BackgroundJobFailed();
                    }

                    const d = await BackgroundProcess.find(backgroundProcessId)
                        .segment('data')
                        .post(extra);

                    return resolve(d);
                })
        )
    );
}

async function waitForBackgroundTask(f, get = true) {
    return waitForBackgroundProcess(f, get, 'job');
}

export async function waitForBackgroundChain(f, get = true) {
    return waitForBackgroundProcess(f, get, 'chain');
}

export function waitForBackgroundChainWithData(jobs) {
    return waitForBackgroundProcessWithData(jobs, 'chain');
}

export function waitForBackgroundTaskWithData(jobs) {
    return waitForBackgroundProcessWithData(jobs, 'job');
}

export default waitForBackgroundTask;



// WEBPACK FOOTER //
// ./resources/assets/admin/common/utils/wait-for-background-task.js